
import React, { useEffect, useState } from "react";
import axios from "axios";
import Filters from "../ReportTab/Filters";
import Tables from "./Tables";

const BASE_URL = process.env.REACT_APP_API_URL;
const ENDPOINT = "/dq-hollistic/rule-details";

const DEFAULT_PAGE = 1;
const DEFAULT_PAGE_SIZE = 10;

const RuleDetails = ({ filters, setFilters, onFilterOptionsChange }) => {
  const { parentDomain, domain, subDomain, product } = filters;

  const [filterOptions, setFilterOptions] = useState({
    parentDomains: [], // keep full tree from API
  });

  const [rows, setRows] = useState([]);
  const [ruleCount,setRuleCount]=useState(0)
  const [pagination, setPagination] = useState({
    page: DEFAULT_PAGE,
    pageSize: DEFAULT_PAGE_SIZE,
    totalPages: 0,
    totalCount: 0,
  });
  const [page, setPage] = useState(DEFAULT_PAGE);
  const [pageSize, setPageSize] = useState(DEFAULT_PAGE_SIZE);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [sortBy, setsortBy] = useState(null);
  const [sortTableBy,setsortTableBy] =useState(null)
  const [columnSearch, setColumnSearch] = useState({
  rule_name: "",
  rule_description: "",
  dimension_name: "",
  check_name: "",
  data_asset_name: "",
  data_product_name: "",
  total_row_count: "",
  error_record_count: "",
  quality_score: "",
  execution_date: "",
});


  // Fetch API data
  const fetchData = async (params = {}) => {
    setLoading(true);
    setError(null);

    try {
      const res = await axios.get(`${BASE_URL}${ENDPOINT}`, {
        params: {
          parentDomain: parentDomain === "All Parent Domains" ? "" : parentDomain,
          domain: domain === "All Domains" ? "" : domain,
          subDomain: subDomain === "All Sub Domains" ? "" : subDomain,
          product: product === "All Products" ? "" : product,
          page,
          pageSize,
    sortBy: sortBy,           
  sortOrder: sortTableBy,
          ...params,
        },
      });

      setRows(res.data.data || []);
      setRuleCount(res.data.ruleCount || 0);
      setPagination(res.data.pagination || pagination);

        if (res.data.filters && res.data.filters.parent_domains) {
  // keep local state if you want, but also notify parent
  setFilterOptions({ parentDomains: res.data.filters.parent_domains });
  if (typeof onFilterOptionsChange === "function") {
    onFilterOptionsChange(res.data.filters.parent_domains);
  }
}
    } catch (err) {
      setError("Failed to fetch rule details");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, [parentDomain, domain, subDomain, product, page, pageSize, sortBy, sortTableBy]);
  const searchTimeoutRef = React.useRef(null);
  
  const handleColumnSearch = (key, value) => {
    const updatedSearch = Object.keys(columnSearch).reduce((acc, col) => {
      acc[col] = col === key ? value : "";
      return acc;
    }, {});
    setColumnSearch(updatedSearch);
  
    clearTimeout(searchTimeoutRef.current);
    searchTimeoutRef.current = setTimeout(() => {
      fetchData({ [key]: value });
    }, 500);
  };

  // Handle Parent Domain change
  const handleParentDomainChange = (e) => {
    const newParent = e.target.value;
    let newDomain = "All Domains";
    let newSubDomain = "All Sub Domains";
    let newProduct = "All Products";

    if (newParent !== "All Parent Domains") {
      const selectedParent = filterOptions.parentDomains.find(
        (pd) => pd.parent_domain === newParent
      );
      if (selectedParent) {
        const relatedDomains = selectedParent.domains || [];
        if (relatedDomains.length === 1) {
          newDomain = relatedDomains[0].domain;
          const subDomains = relatedDomains[0].sub_domains || [];
          if (subDomains.length === 1) {
            newSubDomain = subDomains[0].sub_domain;
            const products = subDomains[0].products || [];
            if (products.length === 1) {
              newProduct = products[0];
            }
          }
        }
      }
    }

    setFilters({
      parentDomain: newParent,
      domain: newDomain,
      subDomain: newSubDomain,
      product: newProduct,
    });
    setPage(1);
  };

  // 🔑 Build filtered options (support skipping levels)
  let filteredDomains = [];
  let filteredSubDomains = [];
  let filteredProducts = [];

  // Domains
  if (parentDomain !== "All Parent Domains") {
    const selectedParent = filterOptions.parentDomains.find(
      (pd) => pd.parent_domain === parentDomain
    );
    filteredDomains = selectedParent ? selectedParent.domains : [];
  } else {
    filteredDomains = filterOptions.parentDomains.flatMap((pd) => pd.domains || []);
  }

  // SubDomains
  if (domain !== "All Domains") {
    const selectedDomainObj = filteredDomains.find((d) => d.domain === domain);
    filteredSubDomains = selectedDomainObj ? selectedDomainObj.sub_domains : [];
  } else {
    filteredSubDomains = filteredDomains.flatMap((d) => d.sub_domains || []);
  }

  // Products
  if (subDomain !== "All Sub Domains") {
    const selectedSubDomainObj = filteredSubDomains.find(
      (sd) => sd.sub_domain === subDomain
    );
    filteredProducts = selectedSubDomainObj ? selectedSubDomainObj.products : [];
  } else {
    filteredProducts = filteredSubDomains.flatMap((sd) => sd.products || []);
  }

  return (
    <div>
     

      <div className="pl-4 pr-4">
        <Tables
          tableData={rows}
          loading={loading}
          error={error}
          pagination={pagination}
          ruleCount={ruleCount}
              onColumnSearchChange={handleColumnSearch}
  columnSearch={columnSearch}
          onPageChange={(p) => setPage(p)}
          onPageSizeChange={(s) => {
            setPageSize(s);
            setPage(1);
          }}
          onSortChange={(column, order) => {  
    setsortBy(column);
    setsortTableBy(order)
    console.log("sort by asc", order)
        console.log("sort by asc", column)

  }}

        />
      </div>
    </div>
  );
};

export default RuleDetails;
